import { render } from "./AppSystem.vue?vue&type=template&id=66c430cc"
import script from "./AppSystem.vue?vue&type=script&lang=js"
export * from "./AppSystem.vue?vue&type=script&lang=js"

import "./AppSystem.vue?vue&type=style&index=0&id=66c430cc&lang=scss"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/sgp-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__